import './CollectionUpload.css';

import React, { useState } from 'react'
import { Button, Form, Icon, Modal } from 'semantic-ui-react';


const CollectionUpload = ({ handleSubmit }) => {

    const [modalOpen, setModalOpen] = useState(false);

    const handleSave = (e) => {
        handleSubmit(e);
        setModalOpen(false);
    }

    return (
        <Modal
                className="modal collection-upload"
                closeIcon
                trigger={<Button icon 
                    onClick={() => setModalOpen(true)}
                    data-tooltip="Upload a new sites collection"
                    data-tut="reactour__collections__upload"
                    data-inverted=""
                    >
                        <Icon name='upload' />
                    </Button>}
                open={modalOpen}
                onClose={() => setModalOpen(false)}
            >
                <Modal.Header>Upload a CSV file</Modal.Header>
                <Modal.Content>
                    <Modal.Description>
                        <p>The CSV file shouldn't include a header and format must be for each row representing a site:
                            name,latitude,longitude,height. Optionally an azimuth can be included, in which case a 
                            sectored site with one sector will be created in place of a omni site.
                            It is possible to import multi-sectored sites by specifying each site more times for each 
                            azimuth with additional lines in the file, making sure to use the same name for the site, and 
                            specifying each azimuth in each line.
                        </p>
                        <p>
                            You can find a sample .csv file with 6 omni sites <a href="/help/six_omni_antennas.csv">here</a>, 
                            and a sample .csv file with 2 sector sites <a href="/help/two_antennas_with_azimuth.csv">here.</a>
                        </p>
                        <div className="ui divider"></div>
                    </Modal.Description>
                    <Form onSubmit={handleSave}>
                        <Form.Field>
                            <label>Collection Name</label>
                            <input id="collection_name" />
                        </Form.Field>
                        <Form.Field>
                            <label>CSV File to upload</label>
                            <input id="csv_file" type="file" />
                        </Form.Field>
                        <Form.Button color='green' inverted>
                            <Icon name='checkmark' />Save
                    </Form.Button>
                    </Form>
                </Modal.Content>
            </Modal>
    )
}

export default CollectionUpload;